<template>
  <div>
      <!-- View Modal -->
    <div id="view-modal">
      <b-modal id="modal-user-view" :title='`View ${user.first_name} ${user.last_name}`'>
        <vue-tiny-tabs id="user-view-tabs" :anchor="false" :closable="false" :hideTitle="true" class="tinytabs tabs">
          <div id="user-personal-details-view" class="section tab">
            <h4 class="title"><b><small><b>Personal Info</b></small></b></h4>
            <p><em> First Name: </em>  {{user.first_name}} </p>
            <p><em>Last Name:</em>  {{user.last_name}}  </p>
            <p><em>Email:</em>  {{user.email}}  </p>
            <p><em>Role:</em>  {{user['role.name']}}  </p>
            <p><em>Is Active:</em>  {{ user.is_active }} </p>
          </div>

          <div id="account-status-view" class="section tab">
            <h4 class="title"><b><small><b>Account Status</b></small></b></h4>
            <p v-if="user.activated_on"><em>Activated On:</em>  {{ user.activated_on }} </p>
            <p v-else><em>Activated On:</em>    N/A </p>

            <p><em>Email Confirmed:</em>  {{ user.email_confirmed }} </p>

            <p v-if="user.email_confirmed_on"><em>Email Confirmed On:</em>  {{ user.email_confirmed_on }} </p>
            <p v-else><em>Email Confirmed On:</em>  N/A </p>

            <p v-if="user.email_confirmation_sent_on"><em>Email Confirmation Sent On:</em>  {{ user.email_confirmation_sent_on }} </p>
            <p v-else><em>Email Confirmation Sent On:</em>  N/A </p>

            <p v-if="user.updated_at"><em>Updated On:</em>  {{ user.updated_at }} </p>
            <p v-else><em>Updated On:</em>  N/A </p>

            <p v-if="user.updated_by"><em>Updated By:</em>  {{ user.updated_by }} </p>
            <p v-else><em>Updated By:</em>  N/A </p>

            <p v-if="user.password_reset_on"><em>Password Reset On:</em>  {{ user.password_reset_on }} </p>
            <p v-else><em>Password Reset On:</em>  N/A </p>
          </div>

          <div id="deactivation-deletion-activity-view" class="section tab">
            <h4 class="title"><small><b>Extra Info</b></small></h4>
            <p><em>Created On:</em>  {{ user.created_at }} </p>
            <p><em>Is Deleted:</em>  {{ user.is_deleted }} </p>

            <p v-if="user.deleted_at"><em>Deleted On:</em>  {{ user.deleted_at }} </p>
            <p v-else><em>Deleted On:</em>  N/A </p>

            <p v-if="user.deleted_by"><em>Deleted By:</em>  {{ user.deleted_by }} </p>
            <p v-else><em>Deleted By:</em>  N/A </p>

            <p v-if="user.deactivated_at"><em>Deactivated On:</em>  {{ user.deactivated_at }} </p>
            <p v-else><em>Deactivated On:</em>  N/A </p>

            <p v-if="user.deactivated_by"><em>Deactivated By:</em>  {{ user.deactivated_by }} </p>
            <p v-else><em>Deactivated By:</em>  N/A </p>

            <p v-if="user.reactivated_at"><em>Reactivated On:</em>  {{ user.reactivated_at }} </p>
            <p v-else><em>Reactivated On:</em>  N/A </p>

            <p v-if="user.reactivated_by"><em>Reactivated By:</em>  {{ user.reactivated_by }} </p>
            <p v-else><em>Reactivated By:</em>  N/A </p>
          </div>
        </vue-tiny-tabs>

        <template v-slot:modal-footer="{ ok, cancel, hide }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="md" variant="primary-outline" @click="cancel()">Cancel</b-button>
          <b-button v-b-modal.modal-modal-user-edit data-dismiss="modal" data-target="#modal-user-edit"
                    data-toggle="modal" size="md" variant="primary"> Update
          </b-button>
        </template>
      </b-modal>
    </div>

    <!-- Update Modal -->
    <div id="edit-modal">
      <b-modal id="modal-user-edit" :title="`Edit ${user.first_name} ${user.last_name}`">
        <vue-tiny-tabs id="user-view-tabs" :anchor="false" :closable="false" :hideTitle="true" class="tinytabs tabs">
          <div>
            <form @submit.prevent="onSubmit">
              <!-- User email and role drop down -->
              <user-email-role-component :user="user"></user-email-role-component>

              <mdb-col class="d-flex justify-content-end">
                <!-- Verify User Details/Activate Account Component -->
                <div v-if="!user.is_active && user.email_confirmed">
                  <verify-user-details :user="user"></verify-user-details>
                </div>

                <!-- Deactivate User Component -->
                <deactivate-user :user="user"></deactivate-user>

                <!-- Delete User Component-->
                <delete-user :user="user"></delete-user>
              </mdb-col>
            </form>
          </div>
        </vue-tiny-tabs>
        <template v-slot:modal-footer="{ ok, cancel, hide }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button class="btn btn-outline-danger btn-rounded"
                    size="md" variant="danger-outline" @click="cancel()">Cancel</b-button>
          <b-button class="btn btn-outline-primary btn-rounded"
                    @click="onSubmit" size="md" variant="primary-outline"> Update</b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {mdbCol} from "mdbvue";
import VueTinyTabs from 'vue-tiny-tabs';
import UserEmailRoleComponent from "@/components/in_form/UserEmailRoleComponent";
import DeactivateUser from "@/components/in_form/DeactivateUserComponent";
import DeleteUser from "@/components/in_form/DeleteUserComponent";
import VerifyUserDetails from "@/components/dashboard/VerifyUserDetails";

export default {
name: "UserModals", components: {
    VerifyUserDetails, DeleteUser, DeactivateUser, UserEmailRoleComponent, VueTinyTabs, mdbCol},
  props: {
    user: {
      required: true,
    }
  },
  methods: {
    onSubmit(){
      this.$log.info('user info: ', this.user)
    }
  }
}
</script>
